import React from "react";

import { Theme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import NavLink from "@/components/NavLink";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(4),
  },
  tabs: {
    margin: theme.spacing(0, 4),
    display: "inline-flex",
  },
  link: {
    color: "#8EAFA9",
    display: "block",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "-0.5px",
    padding: theme.spacing(1, 3),
    textDecoration: "none",
  },
  activeLink: {
    color: "#26C9A7",
    borderBottom: "4px solid red",
    borderBottomColor: theme.palette.primary.main,
  },
}));

const DiaryLinks: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        <NavLink
          to="meals"
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          Meal of the day
        </NavLink>
        <NavLink
          to="exercises"
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          Workout of the day
        </NavLink>
        <NavLink
          to="water-intakes"
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          Water Intake
        </NavLink>
        <NavLink
          to="weights"
          className={classes.link}
          activeClassName={classes.activeLink}
        >
          Weight
        </NavLink>
      </div>
      <Outlet />
    </div>
  );
};

export default DiaryLinks;
